module.exports = __webpack_public_path__ + "fonts/TTNormsPro-BlackItalic.116f741b.eot";